import { portfolioData } from './portfolioConfig';

export const usePortfolioData = () => {
  return {
    profile: portfolioData,
    loading: false,
    error: null,
    refreshData: () => Promise.resolve()
  };
}; 